import { NavLink } from 'react-router-dom';
import Image from 'react-bootstrap/Image';
import { List } from 'react-bootstrap-icons';
import LoginImproved from '../../pages/loginb/LoginImproved';
import TokenTimer from '../TokenTimer/TokenTimer';
import ThemeToggle from '../ui/ThemeToggle';
import { useAuth } from '../../contexts/AuthContext';
import { getVisibleMenuItems, splitMenuItems, getMenuLabel, getMenuIcon } from '../sidebar/menuGroups';
import KnowledgeBaseNavItem from './KnowledgeBaseNavItem';
import './headerb.scss';

function HeaderB({ language, onToggleSidebar }) {
    const { loginState, menuItems } = useAuth();

    const visibleItems = getVisibleMenuItems(menuItems, loginState);
    const { direct } = splitMenuItems(visibleItems);

    return (
        <div className="header-bar">
            <div className="header-left">
                <button className="sidebar-toggle" onClick={onToggleSidebar} aria-label="Menü megnyitása">
                    <List size={24} />
                </button>
                <Image src="/pictures/Griff_Logo_100x100_transparent.png" rounded className="header-logo" />
                <h1 className="header-title">GRIFF SPORTEGYESÜLET</h1>
                <nav className="header-direct-links">
                    {direct.map((item) => (
                        item.MenuCode === 'tudasbazis' ? (
                            <KnowledgeBaseNavItem key={item.ID || item.MenuPath} item={item} />
                        ) : (
                            <NavLink
                                key={item.ID || item.MenuPath}
                                to={item.MenuPath}
                                className="header-direct-link"
                                title={getMenuLabel(item)}
                            >
                                {getMenuIcon(item.MenuIcon, 18)}
                                {item.MenuCode !== 'home' && (
                                    <span className="header-direct-link-text">{getMenuLabel(item)}</span>
                                )}
                            </NavLink>
                        )
                    ))}
                </nav>
            </div>
            <div className="header-right">
                <ThemeToggle />
                <TokenTimer />
                <LoginImproved language={language} />
            </div>
        </div>
    );
}

export default HeaderB;
